import { CourtReporterDeliverableType } from '@/apiClient'
import { fileExtension } from '@/utils/file'

export const INVOICE: CourtReporterDeliverableType[] = [
  CourtReporterDeliverableType.invoice,
]

export const TRANSCRIPTS: CourtReporterDeliverableType[] = [
  CourtReporterDeliverableType.transcript_pdf,
  CourtReporterDeliverableType.transcript_txt,
]

const EXTENSIONS: Record<CourtReporterDeliverableType, string[]> = {
  invoice: ['pdf', 'csv', 'xlsx', 'docx'],
  transcript_pdf: ['pdf'],
  transcript_txt: ['txt'],
}

const MIME_TYPES: Record<string, string> = {
  pdf: 'application/pdf',
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  txt: 'text/plain',
}

// A split keeps the invoice on the original event and the transcripts on each witness.
export const acceptedDeliverables = (event: {
  status: string
  is_split_result?: boolean
}): CourtReporterDeliverableType[] => {
  if (event.is_split_result) {
    return TRANSCRIPTS
  }
  if (event.status === 'split') {
    return INVOICE
  }
  return [...INVOICE, ...TRANSCRIPTS]
}

export const deliverableExtensions = (
  deliverables: CourtReporterDeliverableType[],
): string[] =>
  Array.from(new Set(deliverables.flatMap(d => EXTENSIONS[d]))).map(
    extension => `.${extension}`,
  )

export const fileDeliverable = (
  file: Pick<File, 'name'>,
  deliverables: CourtReporterDeliverableType[],
): { deliverable: CourtReporterDeliverableType; mimeType: string } | null => {
  const extension = fileExtension(file.name)
  const deliverable = deliverables.find(d => EXTENSIONS[d].includes(extension))

  return deliverable ? { deliverable, mimeType: MIME_TYPES[extension] } : null
}
